<template>
    <div class="mine-content">
        <div class="mine-header"><span @click="util.goblack()" class="back"><img src="@/assets/images/base/icon_righ_g.png"/></span>Platform Wallet</div>
        <div class="second-pard" v-if="!!usdt_trc20_url">
            <div class="usdtUrl">TRC20</div>
            <div class="qrcode">
              <vue-qr id="qcodesrc" :logoSrc="userInfo.ico_picture_img" :text="usdt_trc20_url" :size="600"></vue-qr>
            </div>
            <div class="usdtUrl">{{ usdt_trc20_url }}</div>
            <div class="downImg">
              <button @click="downqcode()">Download Picture</button>&nbsp;
              <button v-clipboard:error="util.onError" v-clipboard:copy="usdt_trc20_url" v-clipboard:success="util.onCopy">Copy Address</button>
            </div>
        </div>
        <van-loading v-show="showloding" size="50px" color="#1989fa" vertical/>
    </div>
    </template>
    <script>
    import Vue from "vue";
    import vueQr from 'vue-qr'
    import VueClipboard from "vue-clipboard2";
    Vue.use(VueClipboard);
    import { Loading } from "vant";
    Vue.use(Loading);
    export default {
      components: {
          vueQr
      },
      data() {
        return {
          usdt_trc20_url:"",
          showloding: false,
          userInfo:this.util.user
        };
      },
      methods:{
        downqcode(){
          let link = document.getElementById("qcodesrc").src;
          this.util.handleDownloadQrIMg(link);
        },
        findConfig() {
          this.showloding = true;
          this.axios.get(this.api.api_findOneConfigByKeyName, {
              params: {key_name: "usdt_trc20_txt"}
            }).then((res) => {
              this.showloding = false;
              if (res.data.code == 0) {
                this.usdt_trc20_url = res.data.data.key_value;
              }
            }).catch((err) => {
              console.log(err);
            });
        }
      },
      mounted() {
        if (!this.util.user) this.util.topage('login');
        this.userInfo = this.util.user;
        this.findConfig();
      }
    };
    </script>
    <style lang="scss" scoped>
    .mine-content{
      font-size: 0.32rem;
      background: rgb(235, 235, 235);
      color:rgb(103, 103, 103);
      width: 100%;
      height: 100%;
      .mine-header{
        color:black;
        height: 1.2rem;
        display: grid;
        font-weight: bold;
        grid-template-columns: 30% 1fr 30%;
        align-items: center;
        text-align: center;
        .back{
          cursor: pointer;
          img{
            display: block;
            margin-left: 5%;
            width: 18px;
            transform: rotate(180deg);
          }
        }
      }
      .second-pard{
        width: 96%;
        background: white;
        margin: auto;
        padding: 10px 10px;
        border-radius: 10px/10px;
        .qrcode{
          display: flex;
          justify-content: center;
          margin: auto;
          img{
            display: block;
            margin: auto;
            width: 200px;
          }
        }
        .usdtUrl{
            width: auto;
            text-align: center;
            font-size: 0.32rem;
            height: 0.8rem;
            line-height: 0.8rem;
        }
        .downImg{
          display: flex;
          justify-content: center;
          button {
            border-radius: 4px;
            width: 50%;
            height: 0.8rem;
            font-size: 0.34rem;
            background: #628808;
            color: white;
          }
          button:hover {
            background: #628808;
          }
        }
      }
    }
    </style>  